import {brand, Branded, number, TypeOf} from 'io-ts';

interface NonNegativeBrand {
    readonly NonNegative: unique symbol;
}

export const NonNegative = brand(number, (n): n is Branded<number, NonNegativeBrand> => n >= 0, 'NonNegative');

export type NonNegative = TypeOf<typeof NonNegative>;
